import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import { AccountSubnavComponent } from './account-subnav/account-subnav.component';
@NgModule({
  declarations: [PagetitleComponent,  LoaderComponent, AccountSubnavComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TimepickerModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  exports: [PagetitleComponent, LoaderComponent, AccountSubnavComponent]
})
export class UIModule { }
